// Generated using typescript-generator version null on 2017-12-13 15:13:35.

import {Observable} from "rxjs/Rx";
import {Injectable} from "@angular/core";

export class TagLightDto implements Dto {
  libelle: string;
  code: string;
}

export class ArticleDto implements Dto {
  id: number;
  imageId: number;
  libelle: MultilingualDto;
  reference: string;
  conditionnement: MultilingualDto;
  desactivationMessage: MultilingualDto;
  quota: number;
  multiplicateur: number;
  actif: boolean;
  tagAnalyse: string;
}

export class ArticleDetailDto extends ArticleDto {
  particularite: MultilingualDto;
  quantiteMessage: MultilingualDto;
  categorieId: number;
  dateFin: any;
}

export class MultilingualLibelleDto implements Dto {
  id: number;
  libelle: MultilingualDto;
}

export class CategorieDto extends MultilingualLibelleDto {
  imageId: number;
}

export class TagCodeLibelleDto implements Dto {
  code: string;
  libelle: string;
}

export class SaveArticleDto implements Dto {
  autorisations: string[];
  idCategorie: number;
  reference: string;
  label: MultilingualDto;
  conditionnement: MultilingualDto;
  quantiteMessage: MultilingualDto;
  maxQuantite: number;
  multiplicateur: number;
  particularite: MultilingualDto;
  order: number;
  photo: CreateRessourceMultimediaDto;
  desactivationMessage: MultilingualDto;
  actif: boolean;
  tagAnalyse: string;
}

export class GestionArticleDto implements Dto {
  id: number;
  imageId: number;
  libelle: MultilingualDto;
  reference: string;
  order: number;
  categorieLibelle: MultilingualDto;
  tagAnalyse: string;
}

export class SaveCategorieDto implements Dto {
  order: number;
  label: MultilingualDto;
  photo: CreateRessourceMultimediaDto;
}

export class GestionCategorieDto implements Dto {
  id: number;
  imageId: number;
  libelle: MultilingualDto;
  order: number;
}

export class GestionArticleDetailDto extends GestionArticleDto {
  autorisations: string[];
  categorie: MultilingualLibelleDto;
  conditionnement: MultilingualDto;
  quantiteMessage: MultilingualDto;
  maxQuantite: number;
  multiplicateur: number;
  particularite: MultilingualDto;
  ordre: number;
  desactivationMessage: MultilingualDto;
  actif: boolean;
}

export class AbstractLongIdObject implements LongIdObject {
  id: number;
}

export class LigneCommandeMaterielDto extends AbstractLongIdObject implements Dto {
  article: ArticleDto;
  quantite: number;
}

export class CommandeMaterielDto extends AbstractLongIdObject implements Dto {
  etat: EtatCommandeEnum;
  correspondant: string;
  createur: string;
  modifieur: string;
  validateur: string;
  dateCreation: any;
  dateModification: any;
  dateValidation: any;
  dateExport: any;
  commentaire: string;
  lignes: LigneCommandeMaterielDto[];
}

export class Response implements AutoCloseable {
  mediaType: MediaType;
  entity: any;
  lastModified: Date;
  date: Date;
  headers: any;
  allowedMethods: string[];
  cookies: { [index: string]: NewCookie };
  entityTag: EntityTag;
  links: Link[];
  statusInfo: StatusType;
  metadata: any;
  stringHeaders: any;
  status: number;
  length: number;
  language: Locale;
  location: URI;
}

export class CorrespondantDetailsDto {
  code: string;
  nom: string;
  adressePrincipale: AdresseDto;
  adresseLivraison: AdresseDto;
  telephone: string;
  fax: string;
  email: string;
  numFiness: string;
  numAdeli: string;
  codeRpps: string;
  typeCarte: string;
  correspondantParent: string;
}

export class UserInformations {
  id?: string;
  login?: string;
  prenom?: string;
  nom?: string;
  telephone?: string;
  role?: UserRole;
  metadata?: { [index: string]: any };
  lang?: Locale;
  modules?: string[];
  correspondants?: Correspondant[];
  date?: any;
  expires?: any;
  origine?: string;
  url?: string;
  codeRpps?: string;
  properties?: { [index: string]: any };
  'e-mail'?: string;
  daysBeforeExpire: number | undefined | null;
  firstConnection: boolean | undefined | null;

}

export class Profil {
  id?: number;
  libelle?: string;
  champs?: string;
}

export class MultilingualDto implements Dto {
  fr: string;
  en: string;
}

export class CreateRessourceMultimediaDto implements Dto {
  name: string;
  mimeType: string;
  size: number;
  content: string;
}

export interface Dto {
}

export class HistoriqueCommandeMaterielDto extends AbstractLongIdObject implements Dto {
  etat: EtatCommandeEnum;
  correspondant: string;
  createur: string;
  reference: string;
  dateCreation: any;
  dateModification: any;
  nombreArticles: number;
}

export class LightHistoriqueCommandeMaterielDto extends AbstractLongIdObject implements Dto {
  etat: EtatCommandeEnum;
  correspondant: string;
  createur: string;
  reference: string;
  dateModification: string;
  nombreArticles: number;
}

export class GedFileDescription {
  url: string;
  nom: string;
  locale: Locale;
}

export class MediaType {
  type: string;
  subtype: string;
  parameters: { [index: string]: string };
  wildcardType: boolean;
  wildcardSubtype: boolean;
}

export class Cookie {
  name: string;
  value: string;
  version: number;
  path: string;
  domain: string;
}

export class NewCookie extends Cookie {
  comment: string;
  maxAge: number;
  expiry: Date;
  secure: boolean;
  httpOnly: boolean;
}

export class EntityTag {
  value: string;
  weak: boolean;
}

export class Link {
  rel: string;
  uriBuilder: UriBuilder;
  rels: string[];
  uri: URI;
  params: { [index: string]: string };
  title: string;
  type: string;
}

export interface StatusType {
  family: Family;
  statusCode: number;
  reasonPhrase: string;
}

export class Locale implements Cloneable, Serializable {
}

export class URI implements Comparable<URI>, Serializable {
}

export interface AutoCloseable {
}

export class AdresseDto {
  ligne1: string;
  ligne2: string;
  ligne3: string;
  codePostal: string;
  ville: string;
  pays: string;
}

export class CorrespondantDto implements Dto {
  code: string;
  nom: string;
  tags: string[];
}

export class Correspondant {
  code: string;
  nom: string;
  tags: string[];
  dateDesactivation: any;
  metadata: { [index: string]: any };
}

export interface LongIdObject {
  id: number;
}

export class UriBuilder {
}

export interface Cloneable {
}

export interface Serializable {
}

export interface Comparable<T> {
}

export abstract class HttpClient {

  abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

@Injectable()
export class IAuditWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /info
   * Response code 200 - Le log a Ã©tÃ© ajoutÃ© avec succÃ¨s
   * Response code 500 - Erreur interne lors du log d'audit
   * HTTP POST /audit/info
   * Java method: fr.cerba.digicerba.authentification.webservices.audit.IAuditWebService.info
   */
  info(queryParams?: { url?: string; message?: string; }): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`audit/info`, queryParams: queryParams});
  }
}

@Injectable()
export class IArticlesWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * categorie/{id}
   * Response code 200 - Retourne la liste des articles de la catÃ©gorie
   * HTTP GET /article/categorie/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IArticlesWebService.rechercheArticles
   */
  rechercheArticles(id: number): RestResponse<ArticleDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`article/categorie/${id}`});
  }

  /**
   * {id}
   * Response code 200 - Retourne l'article correspondant Ã  l'id
   * HTTP GET /article/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IArticlesWebService.recupererArticle
   */
  recupererArticle(id: number): RestResponse<ArticleDetailDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`article/${id}`});
  }
}

@Injectable()
export class ICategoriesWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * referentiel
   * Response code 200 - Retourne la liste des catÃ©gories pour rÃ©fÃ©rentiel
   * HTTP GET /categorie/referentiel
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.ICategoriesWebService.categoriesReferentiel
   */
  categoriesReferentiel(): RestResponse<MultilingualLibelleDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`categorie/referentiel`});
  }

  /**
   * all
   * Response code 200 - Retourne la liste des catÃ©gories
   * HTTP GET /categorie/all
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.ICategoriesWebService.rechercheCategories
   */
  rechercheCategories(): RestResponse<CategorieDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`categorie/all`});
  }

  /**
   * {id}
   * Response code 200 - Retourne la catÃ©gorie correspondant Ã  l'id
   * HTTP GET /categorie/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.ICategoriesWebService.recupererCategorie
   */
  recupererCategorie(id: number): RestResponse<CategorieDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`categorie/${id}`});
  }
}

@Injectable()
export class IGestionCatalogueWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * article/create
   * Response code 200 - Retourne l'article crÃ©Ã©
   * HTTP POST /gestion/catalogue/article/create
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.createArticle
   */
  createArticle(arg0: SaveArticleDto): RestResponse<GestionArticleDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`gestion/catalogue/article/create`, data: arg0});
  }

  /**
   * categorie/create
   * Response code 200 - Retourne la catÃ©gorie crÃ©Ã©
   * HTTP POST /gestion/catalogue/categorie/create
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.createCategorie
   */
  createCategorie(arg0: SaveCategorieDto): RestResponse<GestionCategorieDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`gestion/catalogue/categorie/create`, data: arg0});
  }

  /**
   * article/delete
   * Response code 200 - Supprime logiquement l'article
   * HTTP DELETE /gestion/catalogue/article/delete/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.deleteArticle
   */
  deleteArticle(id: number): RestResponse<void> {
    return this.httpClient.request({method: 'DELETE', url: uriEncoding`gestion/catalogue/article/delete/${id}`});
  }

  /**
   * categorie/delete
   * Response code 200 - Supprime logiquement la catÃ©gorie
   * HTTP DELETE /gestion/catalogue/categorie/delete/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.deleteCategorie
   */
  deleteCategorie(id: number): RestResponse<void> {
    return this.httpClient.request({method: 'DELETE', url: uriEncoding`gestion/catalogue/categorie/delete/${id}`});
  }

  /**
   * article/{id}
   * Response code 200 - Retourne l'article demandÃ©
   * HTTP GET /gestion/catalogue/article/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.getArticle
   */
  getArticle(id: number): RestResponse<GestionArticleDetailDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`gestion/catalogue/article/${id}`});
  }

  /**
   * article/all
   * Response code 200 - Retourne la liste des articles
   * HTTP GET /gestion/catalogue/article/all
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.getArticles
   */
  getArticles(): RestResponse<GestionArticleDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`gestion/catalogue/article/all`});
  }

  /**
   * authorisations/all
   * Response code 200 - Retourne la liste des tags d'autorisation
   * HTTP GET /gestion/catalogue/authorisations/all
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.rechercheAuthorisations
   */
  getAutorisations(): RestResponse<TagCodeLibelleDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`gestion/catalogue/authorisations/all`});
  }

  /**
   * categorie/{id}
   * Response code 200 - Retourne la catÃ©gorie demandÃ©e
   * HTTP GET /gestion/catalogue/categorie/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.getCategorie
   */
  getCategorie(id: number): RestResponse<GestionCategorieDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`gestion/catalogue/categorie/${id}`});
  }

  /**
   * categorie/all
   * Response code 200 - Retourne la liste des catÃ©gories
   * HTTP GET /gestion/catalogue/categorie/all
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.getCategories
   */
  getCategories(): RestResponse<GestionCategorieDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`gestion/catalogue/categorie/all`});
  }

  /**
   * article/update
   * Response code 200 - Retourne l'article modifiÃ©
   * HTTP PUT /gestion/catalogue/article/update/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.updateArticle
   */
  updateArticle(id: number, arg1: SaveArticleDto): RestResponse<GestionArticleDto> {
    return this.httpClient.request({
      method: 'PUT',
      url: uriEncoding`gestion/catalogue/article/update/${id}`,
      data: arg1
    });
  }

  /**
   * categorie/update
   * Response code 200 - Retourne la catÃ©gorie modifiÃ©
   * HTTP PUT /gestion/catalogue/categorie/update/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.catalogue.IGestionCatalogueWebService.updateCategorie
   */
  updateCategorie(id: number, arg1: SaveCategorieDto): RestResponse<GestionCategorieDto> {
    return this.httpClient.request({
      method: 'PUT',
      url: uriEncoding`gestion/catalogue/categorie/update/${id}`,
      data: arg1
    });
  }
}

@Injectable()
export class ICommandeMaterielWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * addLigneCommande
   * Response code 200 - Retourne la commande courante (Panier) avec l'ajout d'article
   * HTTP PUT /commande/add/{idCommande}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.addLigneCommande
   */
  addLigneCommande(idCommande: number, arg1: LigneCommandeMaterielDto, queryParams?: { dateModification?: any; }): RestResponse<CommandeMaterielDto> {
    return this.httpClient.request({
      method: 'PUT',
      url: uriEncoding`commande/add/${idCommande}`,
      queryParams: queryParams,
      data: arg1
    });
  }

  /**
   * deleteLigneCommande
   * Response code 200 - Retourne la commande courante (Panier) aprÃ¨s suppression d'une ligne
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP DELETE /commande/ligne/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.deleteLigneCommande
   */
  deleteLigneCommande(id: number, queryParams?: { dateModification?: any; }): RestResponse<CommandeMaterielDto> {
    return this.httpClient.request({
      method: 'DELETE',
      url: uriEncoding`commande/ligne/${id}`,
      queryParams: queryParams
    });
  }

  /**
   * export
   * Response code 200 - Export terminÃ©
   * HTTP GET /commande/export
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.exportCommandes
   */
  exportCommandes(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`commande/export`});
  }

  /**
   * findCommande
   * Response code 200 - Retourne la commande (Panier)
   * HTTP GET /commande/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.getCommande
   */
  getCommande(id: number): RestResponse<CommandeMaterielDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`commande/${id}`});
  }

  /**
   * getHistoriqueCommande
   * Response code 200 - Retourne la commande (Panier)
   * HTTP GET /commande/historic/{id}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.getHistoriqueCommande
   */
  getHistoriqueCommande(id: number): RestResponse<CommandeMaterielDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`commande/historic/${id}`});
  }

  /**
   * rechercheCurrentCommande
   * Response code 200 - Retourne la commande courante (Panier)
   * HTTP GET /commande/current
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.rechercheCurrentCommande
   */
  rechercheCurrentCommande(): RestResponse<CommandeMaterielDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`commande/current`});
  }

  /**
   * sauvegarde commentaire
   * Response code 200 - L'enregistrement est validÃ©
   * HTTP PUT /commande/{id}/comment
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.saveComment
   */
  saveComment(id: number, arg1: string): RestResponse<CommandeMaterielDto> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`commande/${id}/comment`, data: arg1});
  }

  /**
   * searchCommandeHistorics
   * Response code 200 - Retourne une liste de commandes pour l'historique
   * HTTP GET /commande/historics
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.searchCommandeHistorics
   */
  searchCommandeHistorics(): RestResponse<LightHistoriqueCommandeMaterielDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`commande/historics`});
  }

  /**
   * updateQuantiteLigneCommande
   * Response code 200 - Retourne la commande courante (Panier) aprÃ¨s suppression d'une ligne
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP PUT /commande/ligne/{id}/{quantite}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.updateQuantiteLigneCommande
   */
  updateQuantiteLigneCommande(id: number, quantite: number, queryParams?: { dateModification?: any; }): RestResponse<CommandeMaterielDto> {
    return this.httpClient.request({
      method: 'PUT',
      url: uriEncoding`commande/ligne/${id}/${quantite}`,
      queryParams: queryParams
    });
  }

  /**
   * validateCurrentCommande
   * Response code 200 - Retourne la commande courante (Panier) validÃ©e
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP PUT /commande/validate/{idCommande}
   * Java method: fr.cerba.digicerba.cataloguemateriel.webservices.commande.ICommandeMaterielWebService.validateCurrentCommande
   */
  validateCurrentCommande(idCommande: number, queryParams?: { dateModification?: any; }): RestResponse<CommandeMaterielDto> {
    return this.httpClient.request({
      method: 'PUT',
      url: uriEncoding`commande/validate/${idCommande}`,
      queryParams: queryParams
    });
  }
}

@Injectable()
export class IGedWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /search
   * Response code 204 - *Retourne la liste des fichiers associÃ©s Ã  un tag
   * HTTP GET /ged/search
   * Java method: fr.cerba.digicerba.ged.webservices.IGedWebService.searchFiles
   */
  searchFiles(queryParams?: { tag?: string; }): RestResponse<GedFileDescription[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ged/search`, queryParams: queryParams});
  }
}

@Injectable()
export class IRessourceMultimediaWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /{id}
   * Response code 200 - Ressource multimedia rÃ©cupÃ©rÃ©e avec succÃ¨s
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration du contenu
   * HTTP GET /ressourcemultimedia/{id}
   * Java method: fr.cerba.digicerba.resourcemultimedia.webservices.IRessourceMultimediaWebService.getRessourceMultimedia
   */
  getRessourceMultimedia(id: number): RestResponse<Response> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ressourcemultimedia/${id}`});
  }
}

@Injectable()
export class ICorrespondantWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getAllTags
   */
  getAllTags(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags/all`});
  }

  /**
   * /
   * Response code 200 - Retourne le dÃ©tail des infos d'un correspondant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/{code}/details
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondantDetails
   */
  getCorrespondantDetails(code: string): RestResponse<CorrespondantDetailsDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/${code}/details`});
  }

  /**
   * /
   * Response code 200 - Retourne la liste des correspondant de l'utilisateur courant avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/all`});
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/tags
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getTags
   */
  getTags(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags`});
  }
}

@Injectable()
export class INotificationsCommonWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * messages/count
   * HTTP GET /notification/messages/count
   * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.countMessageNotifications
   */
  countMessageNotifications(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/messages/count`});
  }
}

@Injectable()
export class ITechnicWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /correspondant/all
   * Response code 200 - Retourne les correspondants actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/correspondants/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/correspondants/all`});
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTags
   */
  getTags(queryParams?: { locale?: string; }): RestResponse<TagLightDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/tags/all`, queryParams: queryParams});
  }
}

@Injectable()
export class IUserInformationsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /check
   * Response code 200 - Retourne true si le module est accessible
   * Response code 401 - Le module n'est pas accessible
   * HTTP GET /check
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.checkAccess
   */
  checkAccess(): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`check`});
  }

  /**
   * /
   * Response code 200 - Retourne les informations de l'utilisateur avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /me
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.me
   */
  me(): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`me`});
  }
}

export type RestResponse<R> = Observable<R>;

export type EtatCommandeEnum = 'EN_COURS' | 'EN_COURS_VALIDATION' | 'VALIDEE' | 'TERMINEE';

export type UserRole =
  'COMPTE_LIE'
  | 'INVITE'
  | 'ANCIEN_COMPTE'
  | 'ADMINISTRATEUR'
  | 'RESPONSABLE'
  | 'MODULE'
  | 'PROSPECT';

export type Family = 'INFORMATIONAL' | 'SUCCESSFUL' | 'REDIRECTION' | 'CLIENT_ERROR' | 'SERVER_ERROR' | 'OTHER';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '/commande-materiel/api/';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/common/resources/resources.ts